import * as React from "react";

import DocCustomizeActivitiesModal from "./CustomizeActivitiesModal";

interface DocModalProps {
  displayState: DisplayState;
  currentDocument: CurrentDocument;
  currentVersion: CurrentVersion;
  currentUser: CurrentUser;
  currentRoleDefinition: CurrentRoleDefinition;
  currentDocumentSetDocumentRelation?: CurrentDocumentSetDocumentRelation;
  possibleActivities: Array<CombineActivitiesReturnType>;
}

export default function DocModals(props: DocModalProps) {
  const {
    displayState,
    currentDocument,
    currentVersion,
    currentUser,
    currentRoleDefinition,
    currentDocumentSetDocumentRelation,
    possibleActivities,
  } = props;

  switch (displayState.openMenu?.name) {
    case "CUSTOMIZE_ACTIVITIES_MODAL":
      return (
        <DocCustomizeActivitiesModal
          currentDocument={currentDocument}
          currentVersion={currentVersion}
          currentUser={currentUser}
          currentRoleDefinition={currentRoleDefinition}
          currentDocumentSetDocumentRelation={currentDocumentSetDocumentRelation}
          displayState={displayState}
          possibleActivities={possibleActivities}
        />
      );
    default:
      return null;
  }
}
